import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ChevronRightIcon, CheckIcon } from 'lucide-react';
interface BookingPanelProps {
  isOpen: boolean;
  onClose: () => void;
}
const services = [{
  name: 'Precision Cut',
  price: '£25',
  duration: '45 min'
}, {
  name: 'Skin Fade',
  price: '£30',
  duration: '60 min'
}, {
  name: 'Beard Sculpt',
  price: '£15',
  duration: '30 min'
}, {
  name: 'Full Experience',
  price: '£40',
  duration: '90 min'
}];
const barbers = [{
  name: 'Marcus Chen',
  specialty: 'Precision Fades'
}, {
  name: 'James Wilson',
  specialty: 'Classic Cuts'
}, {
  name: 'David Rodriguez',
  specialty: 'Beard Specialist'
}];
const times = ['10:00 AM', '11:30 AM', '1:00 PM', '2:30 PM', '4:00 PM', '5:30 PM'];
export function BookingPanel({
  isOpen,
  onClose
}: BookingPanelProps) {
  const [step, setStep] = useState(1);
  const [selectedService, setSelectedService] = useState('');
  const [selectedBarber, setSelectedBarber] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const handleNext = () => {
    if (step < 3) setStep(step + 1);
  };
  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };
  const handleClose = () => {
    onClose();
    setTimeout(() => {
      setStep(1);
      setSelectedService('');
      setSelectedBarber('');
      setSelectedTime('');
    }, 300);
  };
  return <AnimatePresence data-id="element-48">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={handleClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100]" data-id="element-49" />

          {/* Panel */}
          <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 30,
        stiffness: 300
      }} className="fixed right-0 top-0 bottom-0 w-full md:w-[500px] bg-matte-black border-l border-off-white/10 z-[101] overflow-y-auto" data-id="element-50">
            <div className="p-8" data-id="element-51">
              {/* Header */}
              <div className="flex items-center justify-between mb-8" data-id="element-52">
                <h2 className="font-playfair text-3xl font-bold text-off-white" data-id="element-53">
                  Book Appointment
                </h2>
                <button onClick={handleClose} className="text-off-white/60 hover:text-off-white transition-colors" data-id="element-54">
                  <XIcon size={28} data-id="element-55" />
                </button>
              </div>

              {/* Progress */}
              <div className="flex items-center gap-2 mb-8" data-id="element-56">
                {[1, 2, 3].map(num => <div key={num} className="flex items-center flex-1" data-id="element-57">
                    <div className={`h-1 flex-1 rounded-full transition-colors ${num <= step ? 'bg-soft-gold' : 'bg-off-white/20'}`} data-id="element-58" />
                  </div>)}
              </div>

              {/* Urgency text */}
              <motion.p initial={{
            opacity: 0,
            y: -10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-soft-gold text-sm font-inter mb-8 text-center" data-id="element-59">
                ⚡ Limited slots available today
              </motion.p>

              {/* Step content */}
              <AnimatePresence mode="wait" data-id="element-60">
                {step === 1 && <motion.div key="step1" initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.3
            }} data-id="element-61">
                    <h3 className="font-inter text-xl font-semibold text-off-white mb-6" data-id="element-62">
                      Select Service
                    </h3>
                    <div className="space-y-4" data-id="element-63">
                      {services.map(service => <motion.button key={service.name} onClick={() => setSelectedService(service.name)} whileHover={{
                  scale: 1.02
                }} whileTap={{
                  scale: 0.98
                }} className={`w-full p-4 rounded-lg border transition-all text-left ${selectedService === service.name ? 'border-soft-gold bg-soft-gold/10' : 'border-off-white/20 bg-off-white/5 hover:border-off-white/40'}`} data-id="element-64">
                          <div className="flex items-center justify-between" data-id="element-65">
                            <div data-id="element-66">
                              <div className="font-inter font-semibold text-off-white" data-id="element-67">
                                {service.name}
                              </div>
                              <div className="text-sm text-off-white/60 mt-1" data-id="element-68">
                                {service.duration}
                              </div>
                            </div>
                            <div className="font-playfair text-xl text-soft-gold" data-id="element-69">
                              {service.price}
                            </div>
                          </div>
                        </motion.button>)}
                    </div>
                  </motion.div>}

                {step === 2 && <motion.div key="step2" initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.3
            }} data-id="element-70">
                    <h3 className="font-inter text-xl font-semibold text-off-white mb-6" data-id="element-71">
                      Select Barber
                    </h3>
                    <div className="space-y-4" data-id="element-72">
                      {barbers.map(barber => <motion.button key={barber.name} onClick={() => setSelectedBarber(barber.name)} whileHover={{
                  scale: 1.02
                }} whileTap={{
                  scale: 0.98
                }} className={`w-full p-4 rounded-lg border transition-all text-left ${selectedBarber === barber.name ? 'border-soft-gold bg-soft-gold/10' : 'border-off-white/20 bg-off-white/5 hover:border-off-white/40'}`} data-id="element-73">
                          <div className="font-inter font-semibold text-off-white" data-id="element-74">
                            {barber.name}
                          </div>
                          <div className="text-sm text-off-white/60 mt-1" data-id="element-75">
                            {barber.specialty}
                          </div>
                        </motion.button>)}
                    </div>
                  </motion.div>}

                {step === 3 && <motion.div key="step3" initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.3
            }} data-id="element-76">
                    <h3 className="font-inter text-xl font-semibold text-off-white mb-6" data-id="element-77">
                      Select Time
                    </h3>
                    <div className="grid grid-cols-2 gap-4" data-id="element-78">
                      {times.map(time => <motion.button key={time} onClick={() => setSelectedTime(time)} whileHover={{
                  scale: 1.05
                }} whileTap={{
                  scale: 0.95
                }} className={`p-4 rounded-lg border transition-all ${selectedTime === time ? 'border-soft-gold bg-soft-gold/10' : 'border-off-white/20 bg-off-white/5 hover:border-off-white/40'}`} data-id="element-79">
                          <div className="font-inter font-semibold text-off-white text-center" data-id="element-80">
                            {time}
                          </div>
                        </motion.button>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>

              {/* Navigation buttons */}
              <div className="flex gap-4 mt-8" data-id="element-81">
                {step > 1 && <motion.button onClick={handleBack} whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="flex-1 py-3 rounded-full border border-off-white/20 text-off-white font-inter font-semibold hover:bg-off-white/5 transition-colors" data-id="element-82">
                    Back
                  </motion.button>}

                <motion.button onClick={step === 3 ? handleClose : handleNext} disabled={step === 1 && !selectedService || step === 2 && !selectedBarber || step === 3 && !selectedTime} whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="flex-1 py-3 rounded-full bg-soft-gold text-matte-black font-inter font-bold disabled:opacity-50 disabled:cursor-not-allowed hover:shadow-[0_0_20px_rgba(212,175,55,0.5)] transition-shadow flex items-center justify-center gap-2" data-id="element-83">
                  {step === 3 ? <>
                      <CheckIcon size={20} data-id="element-84" />
                      Confirm Booking
                    </> : <>
                      Next
                      <ChevronRightIcon size={20} data-id="element-85" />
                    </>}
                </motion.button>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}